import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_API_URL;
  const [profile,setProfile]=useState({})

  const handleNavigation = (path) => {
    navigate(path);
  };

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(`${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await profileRes.json();
      const profileData = res.users
      console.log(profileData)
      setProfile(profileData)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchUserData();
  }, [])
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & Description */}
        <div className="footer-section">
          <h2 className="footer-logo">
            {profile?.profilePic ? (
              <img
                src={`${url}/uploads/profile/${profile.profilePic}`}
                alt="Logo"
                style={{ height: "40px", objectFit: "contain" }}
              />
            ) : (
              profile?.orignal_logoname || "Dummy"
            )}
          </h2>
          <p>Your one-stop destination for premium products at unbeatable prices.</p>
          {/* <div className="social-icons">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-instagram" ></i>
            <i className="fab fa-twitter" ></i>
            <i className="fab fa-youtube"></i>
          </div> */}
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li onClick={() => handleNavigation("/")}>Home</li>
            <li onClick={() => handleNavigation("/shop")}>Shop</li>
            <li onClick={() => handleNavigation("/about")}>About Us</li>
            <li onClick={() => handleNavigation("/contact")}>Contact</li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            {/* <li onClick={() => handleNavigation("/faq")}>FAQ</li> */}
            <li onClick={() => handleNavigation("/refund-policy")}>Refund Policy</li>
            <li onClick={() => handleNavigation("/privacy-policy")}>Privacy Policy</li>
            <li onClick={() => handleNavigation("/terms-and-conditions")}>Terms & Conditions</li>
            <li onClick={() => handleNavigation("/enquiry-form")}>Enquiry</li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-section newsletter">
          <h3>Subscribe to Our Newsletter</h3>
          <p>Get the latest updates on new arrivals and exclusive discounts.</p>
          <div className="newsletter-box">
            <input type="email" placeholder="Enter your email" />
            <button className="subscribe-btn" >
              <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {currentYear} <a href="https://100billiontech.com/ownership" target="_blank">All right reserved</a>, powered by <a href="https://100billiontech.com/" target="_blank">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
